import { Fragment, memo, useEffect, useState } from 'react';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import Accountholder from '../shared/accountholder';
import Applicant from '../shared/applicant';
import Payment from '../shared/fragment-payment';
import { useFormikContext } from 'formik';
import { ClaimsFormVM } from 'front-office/view-models/claims/claims-form';

interface ClaimsFormProps {
  disabled?: boolean;
}

const ClaimsFormComponent = ({ disabled }: ClaimsFormProps): React.ReactElement => {
  const [urls, setUrls] = useState({
    applicant: `${__PERSON_API_URL__}/persona/autentiche`,
    accountholder: `${__PERSON_API_URL__}/persona`,
  });
  const formikContext = useFormikContext<ClaimsFormVM>();
  useEffect(() => {
    if (formikContext.values.accountholder?.sameApplicant) {
      setUrls({
        applicant: `${__PERSON_API_URL__}/persona/autentiche`,
        accountholder: `${__PERSON_API_URL__}/persona`,
      });
    } else {
      setUrls({
        accountholder: `${__PERSON_API_URL__}/persona/autentiche`,
        applicant: `${__PERSON_API_URL__}/persona`,
      });
    }
  }, [formikContext.values.accountholder?.sameApplicant]);

  return (
    <Fragment>
      <Payment />
      <Applicant disabled={disabled} hasAccountholder={false} url={urls.applicant} />
      <Accountholder isForAttestazione url={urls.accountholder} />
    </Fragment>
  );
};

ClaimsFormComponent.displayName = 'Claims Form component';

const ClaimsForm = memo(ClaimsFormComponent);

export default ClaimsForm;
